// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Separator } from '@/common-utils/components/ui/separator';
// Common
import { ENVELOPES } from '../../api/apiUrls';
import ENVELOPE_IMPORT_API_REPORT from './EnvelopeImportApiReport';
// Lang
import { nsEnvelope } from '@/app/i18n/namespaces';

let uploadedLinesCount = 0;

// Get the items for the error
const getErrorItems = (errorConfig, fileDetails) => {
    const items = fileDetails?.[errorConfig.key] ?? [];
    return errorConfig?.filter ? errorConfig?.filter(items) : items;
};

// Get the list of errors that are present in the file
const getFileDetailsErrors = (fileDetails) => {
    return Object.values(ENVELOPE_IMPORT_API_REPORT).filter(
        (errorConfig) => getErrorItems(errorConfig, fileDetails).length > 0
    );
};

const EnvelopeImportProps = {
    apiUrl: ENVELOPES.FILE_ACTION.url,
    namespace: nsEnvelope,
    entityPrefix: 'modal.import',
    fileExampleProperties: {
        name: 'prog_envelopes_example.csv.csv',
        path: '/static/resource/files/prog_envelopes_example.csv'
    },
    uploadProperties: {
        fileExtAccepted: ['.csv'],
        typeOfUpload: 'text',
        invalidFileEntity: 'modal.import.error.invalid_file'
    },
    countLines: (fileData) => {
        const fileLines = fileData.split('\n');
        const itemsSet = new Set();
        // Check column index of Serial number
        const columnIndex = fileLines && fileLines.length ? fileLines[0].split(';').findIndex((col) => col === 'SerialNumber') : null;

        // Count the number of envelopes in the file if Serial Number column is found
        // Empty strings are not counted
        if (columnIndex !== null && columnIndex !== -1) {
            for (let i = 1; i < fileLines.length; i++) {
                // Prevent empty lines and empty cells
                if (fileLines[i] && fileLines[i].split(';')[columnIndex]) {
                    fileLines[i].split(';')[columnIndex].split(',').forEach((item) => {
                        if (item.trim()) {
                            itemsSet.add(item.toLowerCase().trim());
                        }
                    });
                }
            }
        }

        // Update the number of uploaded lines
        uploadedLinesCount = itemsSet.size;

        return { numberOfLines: itemsSet.size, file: fileData };
    },
    explanations: () => {
        return (<>
            <Entity entity='modal.import.explanations.header' namespace={nsEnvelope} />
            <ul className='list-disc list-outside [&_ul]:list-[revert] ml-8'>
                <li><Entity entity='modal.import.explanations.serial_number' namespace={nsEnvelope} /></li>
                <li><Entity entity='modal.import.explanations.client' namespace={nsEnvelope} /></li>
                <li><Entity entity='modal.import.explanations.start_date' namespace={nsEnvelope} /></li>
                <li><Entity entity='modal.import.explanations.end_date' namespace={nsEnvelope} /></li>
                <li><Entity entity='modal.import.explanations.access_code' namespace={nsEnvelope} /></li>
                <li><Entity entity='modal.import.explanations.server_ip' namespace={nsEnvelope} /></li>
            </ul>
        </>);
    },
    confirmation: (numberOfLines) => {
        return <Entity
            entity={numberOfLines === 1 ? 'modal.import.confirmation.single' : 'modal.import.confirmation.multiple'}
            namespace={nsEnvelope}
            data={{ numberOfEnvelopes: numberOfLines }}
        />;
    },
    isFileOnError: (fileDetails) => getFileDetailsErrors(fileDetails).length > 0,
    renderPostImportErrors: (fileDetails, error) => {
        const isCsvUploadOnError = error?.response?.data;
        const isFileOnError = getFileDetailsErrors(fileDetails).length > 0;

        if (isCsvUploadOnError) {
            const errorCode = error.response.data.errorCode;
            if (errorCode === 'BAD_FORMAT') {
                return (
                    <div>
                        <Entity entity='modal.import.error.BAD_FORMAT' namespace={nsEnvelope} />
                        <br />
                        <br />
                        <Entity entity='modal.import.error.get_example_file' namespace={nsEnvelope} />
                    </div>
                );
            } else if (errorCode === 'BAD_FILE_FORMAT') {
                return (
                    <div className='flex flex-col gap-2'>
                        <Entity
                            entity='modal.import.error.BAD_FILE_FORMAT'
                            namespace={nsEnvelope}
                        />
                        <Entity
                            entity='modal.import.message'
                            namespace={nsEnvelope}
                        />
                    </div>
                );
            }
            return (
                <Entity
                    entity='modal.import.error.UNEXPECTED_ERROR'
                    namespace={nsEnvelope}
                />
            );
        }

        if (!isFileOnError) {
            return null;
        }

        // Get the list of errors that are present in the file
        const errorsList = getFileDetailsErrors(fileDetails);

        return (
            <div>
                {errorsList.map((errorConfig, index) => {
                    const items = getErrorItems(errorConfig, fileDetails);
                    const entity = errorConfig.getEntity(items, { numberOfLines: uploadedLinesCount });

                    return (
                        <div key={errorConfig.key}>
                            {index > 0 && <Separator className='my-2' />}
                            <Entity
                                entity={entity}
                                namespace={nsEnvelope}
                                data={errorConfig.getData?.(items)}
                            />
                            {errorConfig.listEntity && errorConfig.getListData && (
                                <div>
                                    <Entity
                                        entity={errorConfig.listEntity}
                                        namespace={nsEnvelope}
                                        data={errorConfig.getListData(items)}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }
};

export default EnvelopeImportProps;